import { ReactComponent as AgentIcon } from 'app/assets/img/agent_icon.svg';
import { ReactComponent as HistoryIcon } from 'app/assets/img/history_icon.svg';
import { ReactComponent as UserIcon } from 'app/assets/img/user_icon.svg';
import React from 'react';

export const AGENT_ROUTE = {
  TRANSACTION_HISTORY: '/transaction-history',
  AGENT_TRANSACTION_HISTORY: '/agent/transaction-history',
  AGENT_PROFILE: '/agent/profile',
  AGENT_TRANSACTION_HISTORY_ORDER_DETAIL: '/order-detail',
  AGENT_LIST_ACCOUNT: '/agent/list-account',
};

export const AGENT_MENU_SIDEBAR = [
  {
    path: AGENT_ROUTE.AGENT_PROFILE,
    label: 'b2b.menu.agent-profile',
    icon: <AgentIcon />,
    selectedPaths: [],
  },
  {
    path: AGENT_ROUTE.AGENT_LIST_ACCOUNT,
    label: 'b2b.menu.agent-list-account',
    icon: <UserIcon />,
    selectedPaths: [],
  },
  {
    path: AGENT_ROUTE.AGENT_TRANSACTION_HISTORY,
    label: 'b2b.menu.agent-transaction-history',
    icon: <HistoryIcon />,
    selectedPaths: [AGENT_ROUTE.AGENT_TRANSACTION_HISTORY_ORDER_DETAIL],
  },
];

export enum HistoryTab {
  DEPOSIT = '0',
  CREDIT = '1',
  PENALTY_FEE = '2',
}

export const TRANSACTION_TAB = [
  {
    value: HistoryTab.DEPOSIT,
    label: 'Deposit',
    // component: <DepositHistory />,
  },
  {
    value: HistoryTab.CREDIT,
    label: 'Credit',
    // component: <CreditHistory />,
  },
  {
    value: HistoryTab.PENALTY_FEE,
    label: 'PenaltyFee',
    // component: <CreditHistory />,
  },
];
export const listOrderTypePenaltyStr = translations => {
  return [
    {
      id: 1,
      label: translations ? translations['b2b.txt.order-exchange'] : '',
      value: 'ZUP',
    },
    {
      id: 2,
      label: translations ? translations['b2b.txt.order-refund'] : '',
      value: 'ZRE',
    },
  ];
};
